export default __webpack_public_path__ + "static/media/magnifying_glass.5feb506c.svg";